import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLang from './locales/en/en.json';
import deLang from './locales/de/de.json';

export const languages: any[] = [
  { key: 'de', short: 'DE', locale: 'de_DE', name: 'Deutschland', flag: '/flags/de.svg' },
  { key: 'en', short: 'EN', locale: 'en_UK', name: 'English', flag: '/flags/en.svg' },
];

export const findLocale = (lang: string): string =>
  languages.find((l) => lang === l.key)?.locale || 'en_UK';

const resources = {
  en: {
    translation: enLang,
  },
  de: {
    translation: deLang,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: 'de',
  fallbackLng: 'de',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
